import React from "react";
import BuyMeACoffeeButton from "./BuyMeACoffeeButton";

const AboutPage = () => {
  return (
    <div className="about-container">
      <h1 className="about-title">About Axy</h1>
      <BuyMeACoffeeButton />
      <section className="welcome-section">
        <h2 className="section-heading">About Us</h2>
        <p className="welcome-text">Welcome to Axy, a playful yet ambitious venture aiming to enhance the scientific experience.
          We envision a broad ecosystem for science enabling researchers to seamlessly find and interact with content, and to
          get recognized for discovering valuable work. At Axy, we're committed to building a platform that empowers the scientific
          community, fostering a more connected, engaging, and informed world of research.</p>
      </section>

      <section className="journey-section">
        <h2 className="section-heading">Our Journey</h2>
        <p className="journey-text">Axy began as a vision to address a key challenges in the scientific community:
          navigating the overwhelming volume of information, starting with scientific conferences. Our solution is 
          a user-friendly app that combines a state-of-the-art recommender system with a powerful search engine,
          enabling researchers to easily access relevant content and manage their conference schedule.</p>
      </section>

      <section className="current-features-section">
        <h2 className="section-heading">Our Current Features</h2>
        <ul className="features-list">
          <li className="feature-item"><span className="feature-highlight">Recommender System:</span> Personalized recommendations to help you discover talks and posters that align with your interests.</li>
          <li className="feature-item"><span className="feature-highlight">Powerful Search:</span> Direct access to relevant content by searching for keywords or authors.</li>
          <li className="feature-item"><span className="feature-highlight">Agenda management:</span> The full program and your personal agenda at your fingertips. No more scrolling through program booklets.</li>
          <li className="feature-item"><span className="feature-highlight">What's Hot?:</span> Trending talks and posters.</li>
          {/* <li className="feature-item"><span className="feature-highlight">Prediction Market:</span> A fun and simplified platform where you can predict the impact of conference articles and see how your assessments compare with others.</li> */}
        </ul>
        <section className="alpha-disclaimer-section">
          <h2 className="disclaimer-section-heading">Disclaimer</h2>
          <p className="disclaimer-text">Please note that Axy is currently in beta.
            This means you might encounter some bugs or issues while using the app.
            We're working very hard to improve and refine Axy, and <a href="https://forms.gle/Pje8D72vqVr7Txre6" className="feedback-link">your feedback</a> is
            invaluable in this process.</p>
        </section>
      </section>

      <section className="future-plans-section">
        <h2 className="section-heading">Future Plans</h2>
        <p className="plans-intro">We're just getting started! Our vision for Axy includes:</p>
        <div className="plans-details">
          <h3 className="plan-title">Advanced search configurations:</h3>
          <ul className="plan-list">
            <li className="plan-item">Progressive filtering</li>
            <li className="plan-item">Graph-based search</li>
            <li className="plan-item">Natural language search</li>
          </ul>
          <h3 className="plan-title">User profile with interests:</h3>
          <ul className="plan-list">
            <p className="market-description">Build a full user profile based on all past publications and current research interests to instantly get good recommendations.</p>
          </ul>
          <h3 className="plan-title">An enhanced prediction market</h3>
          <p className="market-description">Let's face it. We go to conferences not just to consume the absurd amount of new research,
            but we also want to have some fun along the way. To that end, we want to build a prediction market, where you could anonymously
            predict what's going to be hot! With exciting metrics and live leaderboards, we think this could be a conference game-changer!</p>
          <h3 className="plan-title">Matching abstracts to reviewers</h3>
          <p className="market-description">Conference organizers could submit reviewers Google scholar profiles to automatically match 
          them to submitted abstracts. Our algorithm will do the bulk of the work, so the researchers can focus on research.</p>
          {/* <h3 className="plan-title">Broader vision</h3>
          <ul className="vision-list">
            <li className="plan-item">Building a social media platform specifically for scientists, fostering community and collaboration.</li>
            <li className="plan-item">Exploring new mechanisms for funding and recognizing scientific work, whether it is new ideas, reviews, or building tools beneficial for the community.</li>
          </ul> */}
        </div>
      </section>



      <section className="contact-section">
        <h2 className="section-heading">We Want to Hear from You!</h2>
        <p className="contact-intro">Your ideas and suggestions are crucial to our mission. We're building Axy for the scientific community,
          and your input will help shape its future. Here's how you can get involved:</p>
        <ul className="contact-list">
          <li className="contact-item">Feedback: Encounter a bug? Have a suggestion? Let us know via  <a href="https://forms.gle/Pje8D72vqVr7Txre6" className="feedback-link">this form!</a>
            Your insights are vital for our growth and improvement.</li>
          <li className="contact-item">Join the Discussion: Be a part of our community forum to discuss features, share ideas,
            and connect with fellow researchers.</li>
          <li className="contact-item">Contact Us:For direct feedback or inquiries, feel free to write to us at <a href="mailto:axy.org.0@gmail.com" className="contact-email">axy.org.0@gmail.com</a>.</li>
        </ul>
        <p className="join-message">Together, we can create a tool that truly serves the needs and aspirations of the scientific community.
          Join us on this exciting journey to reshape the world of scientific research and collaboration!</p>
      </section>
    </div>
  );
};

export default AboutPage;
